<!-- <div class="row"> -->
<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Tipo catasto'" [valueInput]="element.tipoCatasto?.label"></div>
<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'importo'"
	[labelInput]="'Valore del bene'" [valueInput]="element.valore"></div>
<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'boolean'"
	[labelInput]="'Nuda propriet&agrave;'"
	[valueInput]="element.nudaProprieta"></div>
<!-- </div> -->